import { render, staticRenderFns } from "./FormSeller.vue?vue&type=template&id=0f4acc9e&scoped=true&"
import script from "./FormSeller.vue?vue&type=script&lang=js&"
export * from "./FormSeller.vue?vue&type=script&lang=js&"
import style0 from "./FormSeller.vue?vue&type=style&index=0&id=0f4acc9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f4acc9e",
  null
  
)

export default component.exports